export const mutations = {
  MutationRegisterLoadingStatus(state, status) {
    state.registerLoadingStatus = status;
  },
  MutationRegister(state, register) {
    state.getRegister = register;
  },
  MutationRegister(state, register) {
    state.getRegister = register;
  },
  MutationGoogleProfile(state, googleProfile) {
    state.googleProfile = googleProfile;
  },

  MutationSetAcceptInvitationLoadingStatus(state, status) {
    state.acceptInvitationLoadingStatus = status;
  },
  MutationSetAcceptInvitationModel(state, _acceptInvitationModel) {
    state.acceptInvitationModel = _acceptInvitationModel;
  },
  MutationSetInsertUserProfileConsentLoadingStatus(state, status) {
    state.insertUserProfileConsentLoadingStatus = status;
  },
  MutationSetRegisterModel(state, registerModel) {
    state.registerModel = registerModel;
  },
  MutationSetGetUserProfileConsentLoadingStatus(state, status) {
    state.getUserProfileConsentLoadingStatus = status;
  },
  MutationSetUserprofileConsentModel(state, userprofileConsentModel) {
    state.userprofileConsentModel = userprofileConsentModel;
  },
};
